__turbopack_context__.v({
  "categoryGrid": "CategoryGrid-module-scss-module__z8xguq__categoryGrid",
  "image": "CategoryGrid-module-scss-module__z8xguq__image",
  "imageContainer": "CategoryGrid-module-scss-module__z8xguq__imageContainer",
  "item": "CategoryGrid-module-scss-module__z8xguq__item",
  "link": "CategoryGrid-module-scss-module__z8xguq__link",
  "mobileScroll": "CategoryGrid-module-scss-module__z8xguq__mobileScroll",
  "title": "CategoryGrid-module-scss-module__z8xguq__title",
});
